import * as React from 'react';
import { PageHeader } from '@/components/layout/PageHeader';
import { BillingView } from '@/features/billing/components/BillingView';
import waveContactListSvg from '@/assets/images/svg/wave_element_contact_list.svg';

/** Standalone billing route used by credit-balance and upgrade entry points. */
export const CreditsPage: React.FC = () => (
  <div className='relative size-full overflow-hidden bg-white'>
    <img
      src={waveContactListSvg}
      alt=''
      className='pointer-events-none absolute bottom-0 left-0 z-0 select-none'
    />
    <div className='custom-scrollbar relative z-10 size-full overflow-y-auto p-6 md:p-10'>
      <PageHeader title='BILLING' titleClassName='text-brand-800 !text-left' theme='dark' />
      <BillingView />
    </div>
  </div>
);

export default CreditsPage;
